import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import { actions as acceptInviteToFamilyCircleAction } from '../../../../redux/circles/acceptInviteToFamilyCircle';
import { actions as declineInviteToFamilyCircleAction } from '../../../../redux/circles/declineInviteToFamilyCircle';
import { actions as acceptCaregiverRoleAction } from '../../../../redux/circles/acceptCaregiverRole';
import { actions as declineCaregiverRoleAction } from '../../../../redux/circles/declineCaregiverRole';
import { actions as acceptGuardianRoleAction } from '../../../../redux/circles/accept-guardian-role';
import { actions as declineGuardianRoleAction } from '../../../../redux/circles/decline-guardian-role';
import {
  selectCaregiverInvitationPending,
  selectFamilyInvitationPending,
  selectGuardianInvitationPending,
} from '../../../../redux/circles/selectors';
import { selectScheduledTasks } from '../../../../redux/healthboard/selectors';
import { loggedUserSelector } from '../../../../redux/context/selectors';
import { INVITATION_TYPES, TODO_TYPES } from '../../../../constants';
import { INVITE_TEXT } from '../../../../constants/strings';
import { getFullName } from '../../utils';
import styles from './styles.styl';

const mapStateToProps = state => ({
  sendingCaregiverInvite: selectCaregiverInvitationPending(state),
  sendingGuardianInvite: selectGuardianInvitationPending(state),
  sendingFamilyMemberInvite: selectFamilyInvitationPending(state),
  scheduleTasks: selectScheduledTasks(state),
  loggedUser: loggedUserSelector(state),
});
const mapDispatchToProps = {
  acceptFamilyMemberInvite: acceptInviteToFamilyCircleAction.send,
  declineFamilyMemberInvite: declineInviteToFamilyCircleAction.send,
  acceptCaregiverInvite: acceptCaregiverRoleAction.send,
  declineCaregiverInvite: declineCaregiverRoleAction.send,
  acceptGuardianInvite: acceptGuardianRoleAction.send,
  declineGuardianInvite: declineGuardianRoleAction.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ scheduleTasks, invitationId }) => ({
    invitation: scheduleTasks
      .filter(({ type }) => type === TODO_TYPES.INVITATION)
      .map(({ payload }) => payload)
      .find(({ id }) => id === invitationId),
  })),

  withProps(
    ({
      acceptFamilyMemberInvite,
      declineFamilyMemberInvite,
      declineCaregiverInvite,
      acceptCaregiverInvite,
      acceptGuardianInvite,
      declineGuardianInvite,
      sendingCaregiverInvite,
      sendingGuardianInvite,
      sendingFamilyMemberInvite,
      intl: { formatMessage },
      invitation,
    }) => ({
      getOptions: () => {
        const name = getFullName(get(invitation, 'targetUser'));

        switch (get(invitation, 'type')) {
          case INVITATION_TYPES.FAMILY_MEMBER:
            return {
              renderInfo: () => formatMessage(INVITE_TEXT.family),
              pending: sendingFamilyMemberInvite,
              accept: acceptFamilyMemberInvite,
              decline: declineFamilyMemberInvite,
            };

          case INVITATION_TYPES.CAREGIVER:
            return {
              renderInfo: () =>
                formatMessage(INVITE_TEXT.caregiver, {
                  patient: name,
                }),
              pending: sendingCaregiverInvite,
              accept: acceptCaregiverInvite,
              decline: declineCaregiverInvite,
            };
          case INVITATION_TYPES.GUARDIAN_PROXY:
            return {
              renderInfo: () =>
                formatMessage(INVITE_TEXT.guardian, { patient: name }),
              pending: sendingGuardianInvite,
              accept: acceptGuardianInvite,
              decline: declineGuardianInvite,
            };

          default:
            return {
              renderInfo: () => {},
              accept: () => {},
              decline: () => {},
              pending: false,
            };
        }
      },
    }),
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InvitationDetailsPopup/enhance.jsx